// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__30fCu","footer":"Form_footer__2vX5x"};